import { Shop } from "../../domain/Shop";
import { ShopRepository } from "../../domain/ShopRepository";

export class ShopDeleter{
    private _repository: ShopRepository;
    constructor(repository: ShopRepository){
        this._repository = repository;
    }
    invoke(shop: Shop){
        return this._repository.delete(shop);
    }
}